import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InputText } from "primereact/inputtext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import FilterInput from "./FilterInput";
import { useOutletContext } from "react-router";
import { Dropdown } from "primereact/dropdown";


const FilterBar = ({ isFarmConnections }) => {
    const { t } = useTranslation();
    const { setFilterData, filterData } = useOutletContext() || {};


    return (
        <div className='filter-bar'>
            <div className='d-flex'>
                {isFarmConnections ? (
                    <>
                        <div className="d-flex flex-column mr-2">
                            <label htmlFor="sortDate">{t("marketplace.filterBar.sortBy")}</label>
                            <Dropdown
                                value={filterData.selectedSort}
                                onChange={(e) => setFilterData( prev => ({...prev, selectedSort: e.value}))}
                                options={filterData?.sortOptions ?? []}
                                optionLabel="label"
                                placeholder={t("marketplace.filterBar.sortBy")}
                                className="mkt-dropdown"
                                panelClassName='no-scrollbar mkt-dropdown-popup'
                                data-testid="mkt-dd-sort"
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className='filter-label'>
                            {t("marketplace.filterBar.filterBy")}
                        </div>
                        <div className="d-flex flex-column mr-2">
                            <label htmlFor="filterCategory">{t("marketplace.categoriesLabel")}</label>
                            <FilterInput
                                id="filterCategory"
                                options={filterData?.categoriesOptions ?? []}
                                setSelected={(value) => setFilterData( prev => ({...prev, selectedCategories: value}))}
                                value={filterData.selectedCategories}
                            />
                        </div>
                        <div className="d-flex flex-column">
                            <label htmlFor="filterBy">{t("marketplace.product")}</label>
                            <FilterInput
                                id="filterBy"
                                options={filterData?.typesOptions ?? []}
                                setSelected={(value) => setFilterData( prev => ({...prev, selectedTypes: value}))}
                                value={filterData.selectedTypes}
                            />
                        </div>
                    </>
                )}
            </div>
            <div className='search-box'>
                <span className="p-input-icon-right">
                    <FontAwesomeIcon icon={faSearch} />
                    <InputText value={filterData.searchText} onChange={e => setFilterData( prev => ({...prev, searchText: e.target.value}))} placeholder={t("forms.search")} />
                </span>
            </div>
        </div>
    );
};

export default FilterBar;
